import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import MainLayoutDetail from "../components/layout/MainLayoutDetail";
import MainLayoutUser from "../components/layout/MainLayoutUser";
import MainLayoutAdmin from "../components/layout/MainLayoutAdmin";
import SectionBox from "../components/layout/SectionBox";
import NewsHighlight from "../components/organisms/NewsHighlight";
import NewsGrid from "../components/organisms/NewsGrid";
import NewsCard from "../components/molecules/NewsCard";
import { useAuthStore } from "../store/useAuthStore";
import { useNewsStore } from "../store/useNewsStore";
import PageLoader from "../components/atoms/PageLoader";

const News = () => {
    const { accessToken, type } = useAuthStore();
    const { items, fetchNews, currentPage, totalPages } = useNewsStore();

    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const lang = location.pathname.startsWith("/id") ? "id" : "en";

    useEffect(() => {
        fetchNews(lang, 1).finally(() => setLoading(false));
    }, [lang]);

    //   const highlight = items[0];
    const list = items.slice(1);

    const highlight = items[0];
    const sideCards = items.slice(1, 3);   // 2 card kanan
    const bottomCards = items.slice(3, 6); // 3 card bawah
    const rest = items.slice(6);

    const Layout =
        !accessToken
            ? MainLayoutDetail
            : type === "candidate"
                ? MainLayoutUser
                : type === "company"
                    ? MainLayoutAdmin
                    : MainLayoutDetail;

    return (
        <Layout>
                {loading && <PageLoader />}
            <section id="news-top" className="w-full pt-6">
                <div className="container-section mx-auto px-6">
                    <SectionBox
                        className="mt-24"
                        title={lang === "id" ? "Berita Terbaru" : "Latest News"}
                        titleAlign="left"
                        titleClassName="text-2xl md:text-3xl text-white"
                    >
                        {highlight && (
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                                {/* LEFT – HIGHLIGHT (2 COLS) */}
                                <div className="lg:col-span-2">
                                    <NewsHighlight item={highlight} />
                                </div>

                                {/* RIGHT – 2 STACKED CARDS */}
                                <div className="flex flex-col md:gap-5 gap-10 mb-10">
                                    {sideCards.map((item) => (
                                        <NewsCard key={item.id} item={item} />
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* BOTTOM – 3 CARDS */}
                        {bottomCards.length > 0 && (
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">
                                {bottomCards.map((item) => (
                                    <NewsCard key={item.id} item={item} />
                                ))}
                            </div>
                        )}

                        {/* REST – NORMAL GRID */}
                        {rest.length > 0 && <NewsGrid items={rest} />}

                        {/* PAGINATION */}
                        <div className="flex flex-col items-center mt-12 gap-2">
                            <div className="flex gap-3">
                                <button
                                    disabled={currentPage === 1}
                                    onClick={() => {
                                        fetchNews(lang, currentPage - 1);
                                        const topEl = document.getElementById("news-top");
                                        topEl?.scrollIntoView({ behavior: "smooth" });
                                    }}
                                    className="px-4 py-2 bg-gray-200 rounded-xl disabled:opacity-50"
                                >
                                    Prev
                                </button>

                                <span className="px-4 py-2 bg-blue-600 text-white rounded-xl">
                                    {currentPage}
                                </span>

                                <button
                                    disabled={currentPage === totalPages}
                                    onClick={() => {
                                        fetchNews(lang, currentPage + 1);
                                        const topEl = document.getElementById("news-top");
                                        topEl?.scrollIntoView({ behavior: "smooth" });
                                    }}
                                    className="px-4 py-2 bg-gray-200 rounded-xl disabled:opacity-50"
                                >
                                    Next
                                </button>
                            </div>


                            <p className="text-sm text-gray-400">
                                Page {currentPage} of {totalPages}
                            </p>
                        </div>



                    </SectionBox>
                </div>
            </section>
        </Layout>
    );
};

export default News;
